"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTokenCustomStrategy = void 0;
var privateRefreshTokenCustomMethod;
var execute = function () {
    return privateRefreshTokenCustomMethod().then(function (applicationAccessToken) {
        return {
            applicationAccessToken: applicationAccessToken,
            deviceRefreshToken: undefined,
        };
    });
};
var setRefreshTokenCustomMethod = function (customMethod) {
    privateRefreshTokenCustomMethod = customMethod;
};
exports.refreshTokenCustomStrategy = {
    execute: execute,
    setRefreshTokenCustomMethod: setRefreshTokenCustomMethod,
};
